import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 69.17 63.79"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M40.37 0H28.7L0 63.79h9.78l8.72-14.76 4.01-9.3 11.94-27.88 11.61 26.93.41.95 3.92 9.3.48 1.09 8.38 13.67h9.92z" }, null, -1),
    _createElementVNode("path", { d: "M9.78 63.79H.12s9.19-22.3 34.46-22.3S69 63.79 69 63.79h-9.75s-5-13.22-24.66-13.22C13.54 50.56 9.78 63.79 9.78 63.79" }, null, -1)
  ]))]))
}
export default { render: render }